import { useAsync } from 'react-async-hook';
import useConstant from 'use-constant';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useState } from 'react';

import axios from 'packs/axios';

const trustpilotReviews = async (url, page) =>
  url === null || page === null
    ? undefined
    : await axios
        .get(url, {
          headers: {
            'Content-Type': 'text/javascript',
            Accept: 'text/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          params: { page },
        })
        .then(({ data }) => ({ success: true, data }))
        .catch(({ response }) => {
          if (response) {
            return { success: false, data: response };
          }
          return {
            success: false,
            data: {
              data: { message: 'Network error' },
              status: 500,
              statusText: 'Network error',
            },
          };
        });

const useTrustpilotReviews = () => {
  const [url, setUrl] = useState(null);
  const [page, setPage] = useState(null);

  const debounceTrustpilotReviews = useConstant(() =>
    AwesomeDebouncePromise(trustpilotReviews, 300),
  );

  const response = useAsync(
    async () => debounceTrustpilotReviews(url, page),
    [url, page],
  );

  return {
    response,
    setUrl,
    setPage,
  };
};

export default useTrustpilotReviews;
